const Constantes = {
    //RUTA_API: "http://192.168.1.27/personal-app",
    //Para Producción
    RUTA_API: "http://190.64.95.234:33080/personal-app",
    //RUTA_API: "http://192.168.1.25/personal-app",
};
export default Constantes;